


































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import TransactionFeeGauge from '~/components/SvgIcons/TransactionFeeGauge.vue';
import TransactionFeeSlider from '~/components/Wallet/TransactionFeeSlider.vue';

@Component({
  components: {
    TransactionFeeGauge,
    TransactionFeeSlider,
  },
})
export default class TransactionFeeSelector extends Vue {
  @Prop(Boolean) readonly isFetching!: boolean;
  @Prop(String) readonly transactionFeeCurrency!: string;
  @Prop(Number) readonly transactionFeeMin!: number;
  @Prop(Number) readonly transactionFeeMax!: number;
  @Prop(Number) readonly transactionFeeDefault!: number;
  @Prop(Number) readonly transactionFee!: number;
  @Prop(String) readonly transactionType?: string;

  get getType() {
    return this.transactionType || 'send';
  }

  get gaugeHeight() {
    return this.$vuetify.breakpoint.xs ? 40 : 68;
  }

  get sendingTranslationString() {
    switch (this.transactionType) {
      case 'swap':
        return 'components.wallet.transactionFeeSelector.selectSwapSpeed';
      case 'burn':
        return 'components.wallet.transactionFeeSelector.selectBurnSpeed';
      default:
        return 'components.wallet.transactionFeeSelector.selectSpeed';
    }
  }

  @Emit('feeSelected')
  feeSelected(value: number) {
    return value;
  }
}
